import React, { useRef, useEffect, useState } from 'react';
import styles from './KeyDifferentiatorsSection.module.scss';
import { motion } from 'framer-motion';

const differentiators = [
  {
    title: "NFT Technology",
    description: "Non Fungible Property Token (NFPT) is compliant, portable and secure.",
    icon: "nft" // We'll use CSS to display the icons
  },
  {
    title: "Rewards",
    description: "Rewards paid to investors and platform users.",
    icon: "rewards"
  },
  {
    title: "Liquidity",
    description: "Buy & Sell 24/7. You set the price per piece of property.",
    icon: "liquidity"
  },
  {
    title: "Motivated Agents",
    description: "Buyers agents screen for investment grade properties.",
    icon: "agents"
  },
  {
    title: "Portfolio Diversity",
    description: "Purchase a range of different properties from around Australia.",
    icon: "portfolio"
  },
  {
    title: "Rent-to-Own",
    description: "Priority and preferred tenants can rent-to-own their own home. No banks.",
    icon: "renttoown"
  }
];

const KeyDifferentiatorsSection = () => {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 100) setVisible(true);
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.25,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const iconVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: { 
      scale: 1, 
      opacity: 1,
      transition: { 
        duration: 0.8,
        ease: "easeOut",
        delay: 0.2
      }
    }
  };

  return (
    <section ref={ref} className={styles.section}>
      <div className={styles.card + ' ' + (visible ? styles.visible : '')}>
        <motion.h2 
          className={styles.title}
          initial={{ opacity: 0, y: -15 }}
          animate={visible ? { opacity: 1, y: 0 } : { opacity: 0, y: -15 }}
          transition={{ duration: 0.8 }}
        >
          Key differentiators
        </motion.h2>
        <motion.div 
          className={styles.differentiatorGrid}
          initial="hidden"
          animate={visible ? "visible" : "hidden"}
          variants={containerVariants}
        >
          {differentiators.map((item, index) => (
            <motion.div key={index} className={styles.differentiatorItem} variants={itemVariants}>
              <motion.div 
                className={`${styles.icon} ${styles[item.icon]}`}
                variants={iconVariants}
              ></motion.div>
              <h3 className={styles.itemTitle}>{item.title}</h3>
              <p className={styles.itemDescription}>{item.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default KeyDifferentiatorsSection; 